<template>
    <b-form-group label="Status da Avaliação*" label-for="statusDaAvaliacao"
        label-class="font_size_label statusDaAvaliacao">
        <validation-provider #default="{ errors }" name="Status da Avaliação" :rules="rules">
            <v-select id="statusDaAvaliacao" :options="options" v-model="selected" placeholder="Todos os status"
                :clearable="true">
                <span slot="no-options">Nenhuma opção selecionável.</span>
            </v-select>
            <small v-if="errors[0]" class="text-danger">
                {{ errors[0] }}
            </small>
        </validation-provider>
    </b-form-group>
</template>

<script>
import {
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BSpinner,
    BFormDatepicker,
    BFormTextarea,
    BOverlay,
} from "bootstrap-vue";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";

export default {
    components: {
        BForm,
        BCol,
        BRow,
        BFormGroup,
        BFormInput,
        BButton,
        BTable,
        BSpinner,
        BFormDatepicker,
        BFormTextarea,
        BOverlay,
        ValidationProvider,
        ValidationObserver,
        vSelect,
    },
    props: {
        value: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            options: ["Avaliado", "Ignorado"],
            selected: null,
            rules: "required",
        };
    },
    mounted() {
        this.selected = this.value ?? "Avaliado";
    },
    watch: {
        selected(valor) {
            this.$emit("selected", valor);
        },
    },
};
</script>
